import type { MonthlyClosureReport } from '@vy/types';
import { caseInsensitiveIncludes, isNullOrUndefined } from '@vy/utils';
import { useMemo, } from 'react';
import { VyTableLite } from '../../../../../components/new-design/table/vy-table/VyTable';
import { MONTHLY_CLOSURE_REPORT_COLUMNS } from './MonthlyClosureReportTableColumns';
import { GridApiPro } from '@mui/x-data-grid-pro';

type MonthlyClosureReportTableProps = {
  filter?: string;
  apiRef?: React.MutableRefObject<GridApiPro>;
  isLoading?: boolean;
  rows: MonthlyClosureReport;
};

export const MonthlyClosureReportTable: React.FC<MonthlyClosureReportTableProps> = ({
  isLoading,
  filter,
  rows,
  apiRef,
}) => {
  const filteredRows = useMemo(
    () =>
      rows.filter(
        ({ customerName }) => isNullOrUndefined(filter) || caseInsensitiveIncludes(customerName, filter),
      ),
    [rows, filter],
  );

  return (
    <VyTableLite
      apiRef={apiRef}
      items={filteredRows}
      columns={MONTHLY_CLOSURE_REPORT_COLUMNS}
      loadingItems={isLoading}
      getRowId={() => crypto.randomUUID()}
    />
  );
};
